import { render } from "./EpiPageComponentSelector.vue?vue&type=template&id=19d2e9fa"
import script from "./EpiPageComponentSelector.vue?vue&type=script&lang=js"
export * from "./EpiPageComponentSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__